import { Deserializable } from "@app/interfaces/deserializable";

export class UseNotice implements Deserializable {

    id: number;
    effectDate: Date;
    noticeNum: number;
    contentHtml: string;
    contentText: string;    

    deserialize(input: any) {
        Object.assign(this, input);
        return this;
    }
}
